import { maskCNPJ } from 'utils';
import { backofficeBcertoConfig, backofficeConfig } from 'data/backoffice-config';
import { isBcerto } from "utils";

export const businessName = () => isBcerto? backofficeBcertoConfig.legalName: backofficeConfig.legalName;

export const businessDocument = () => maskCNPJ(isBcerto? backofficeBcertoConfig.legalDocument: backofficeConfig.legalDocument);

export const businessAddress = () => isBcerto? backofficeBcertoConfig.address.line1: backofficeConfig.address.line1;

export const businessAddressLine2 = () => {
  const { line2, city, state, postalCode } = isBcerto? backofficeBcertoConfig.address: backofficeConfig.address;
  const postalCodeFormatted = postalCode.replace(/^(\d{5})(\d{3})$/, "$1-$2");
  return `${line2} - ${city} - ${state} - CEP ${postalCodeFormatted}`;
};

export const businessContact = () => isBcerto?
  `${backofficeBcertoConfig.contactEmail} - ${backofficeBcertoConfig.website}`:
  `${backofficeConfig.contactEmail} - ${backofficeConfig.website}`;
